import React from "react";
import { Pencil, Trash2 } from "lucide-react";

const cell = "px-3 py-2 text-sm border-b border-gray-200";
const th =
  "px-3 py-2 text-xs font-bold text-gray-600 border-b border-gray-300 bg-gray-50";

export default function ResourcesTable({
  items = [],
  loading,
  onEdit,
  onDelete,
  isRtl = true,
}) {
  if (loading) return <p className="text-sm text-gray-500">در حال بارگذاری...</p>;
  if (!items.length) return <p className="text-sm text-gray-500">موردی یافت نشد.</p>;

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
      <table className={`min-w-full ${isRtl ? "text-right" : "text-left"}`}>
        <thead>
          <tr>
            <th className={th}>عنوان</th>
            <th className={th}>نوع</th>
            <th className={th}>تاریخ</th>
            <th className={th}>عملیات</th>
          </tr>
        </thead>

        <tbody>
          {items.map((r) => (
            <tr key={r._id} className="hover:bg-gray-50">
              <td className={cell}>{r.title}</td>
              <td className={cell}>{r.type}</td>
              <td className={cell}>
                {r.createdAt ? new Date(r.createdAt).toLocaleDateString("fa-IR") : "--"}
              </td>

              <td className={cell}>
                <button
                  onClick={() => onEdit(r)}
                  className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
                >
                  <Pencil size={14} /> ویرایش
                </button>

                <button
                  onClick={() => onDelete(r._id)}
                  className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md bg-red-600 text-white hover:bg-red-700 ms-2"
                >
                  <Trash2 size={14} /> حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
